import {
  getDataNotice,
  getNewSletterList,
  getPurchaseHomeApi,
  getTitleTop10ArtistsList,
  getTop10ArtistsList,
  purchaseStatsApi,
} from "apis";
import { MainSlider } from "components";
import React, { useEffect, useState } from "react"; //lazy
import { TemplateMypage } from "templates";
import ArtNewSletter from "./ArtNewSletter";
import ArtNumber from "./ArtNumber";
import ArtReadMore from "./ArtReadMore";
import ArtTop10 from "./ArtTop10";
import moment from "moment-timezone";
import SliderBannerEvent from "components/SliderBannerEvent";
import FloatingBanner from "components/FloatingBanner";
import MobileFloatingBanner from "components/MobileFloatingBanner";
import useWindowSize, { Size } from "hooks/useWindowSize";
import { getBannerList } from "apis/home";

function getAllData(isMobile: boolean) {
  const notice = async () => {
    const noticeData: any = await getDataNotice({
      size: 5,
      categoryCode: "NOTICE",
      page: "",
      query: "",
      hashtag: "",
      startTime: "",
      endTime: "",
      onlyOnePerCate: "1",
    });
    let gongchiData: any = await getDataNotice({
      size: 1,
      categoryCode: "GONGCHI",
      page: "",
      query: "",
      hashtag: "",
      startTime: "",
      endTime: "",
    });

    gongchiData = gongchiData.datas;
    if (gongchiData) {
      for (var i = 0; i < gongchiData.length; i++) {
        gongchiData[i].isPageGongchi = true;
      }
    }

    return [...(gongchiData ?? []), ...(noticeData.datas ?? [])];
  };

  // GroupSale OnSale on Banner
  const purchase = async () => {
    let upcomingData: any = await getPurchaseHomeApi({
      querySearch: undefined,
      typeSearch: "UPCOMING",
      page: 1,
      size: 10,
    });

    let dongoingData: any = await getPurchaseHomeApi({
      querySearch: undefined,
      typeSearch: "ON_GOING",
      page: 1,
      size: 10,
    });

    upcomingData = upcomingData?.data?.datas;
    dongoingData = dongoingData?.data?.datas;

    if (upcomingData) {
      for (var i = 0; i < upcomingData.length; i++) {
        upcomingData[i].isUpcomming = true;
      }
    } else {
      for (var i = 0; i < upcomingData.length; i++) {
        upcomingData[i].isUpcomming = false;
      }
    }

    let dataDongoingData = [];
    if (dongoingData) {
      for (let i = 0; i < dongoingData.length; i++) {
        if (moment(dongoingData[i].endNormalBuyAt) > moment()) {
          dataDongoingData.push(dongoingData[i]);
        }
      }
    }

    return [...dataDongoingData, ...upcomingData];
  };
  // End ----- GroupSale OnSale on Banner -------

  const getPurchaseStatus = async () => {
    const { data }: any = await purchaseStatsApi();
    return data;
  };

  const getBanner = async () => {
    const { datas }: any = await getBannerList({ isMobile: isMobile });
    return datas;
  };

  // Top10 Artists
  const getTop10Artists = async () => {
    const { data }: any = await getTop10ArtistsList({ page: 1, size: 10 });
    return data.datas;
  };

  // NewSletter
  const getNewSletter = async () => {
    const data: any = await getNewSletterList({
      page: "1",
      size: "4",
      authorSearch: "",
      categories: "",
      categoryCode: "NEWS",
      contentSearch: "",
      endTime: "",
      startTime: "",
      hashtag: "",
      query: "",
      titleSearch: "",
    });
    return data.datas;
  };

  const getTitleTop10Artists = async () => {
    const { data }: any = await getTitleTop10ArtistsList();
    return data;
  };

  // ArtInside
  const getArtInside = async () => {
    const data: any = await getNewSletterList({
      page: "1",
      size: "4",
      authorSearch: "",
      categories: "",
      categoryCode: "ART_INSIGHT",
      contentSearch: "",
      endTime: "",
      startTime: "",
      hashtag: "",
      query: "",
      titleSearch: "",
    });
    return data.datas;
  };

  return Promise.all([
    notice(),
    purchase(),
    getPurchaseStatus(),
    getTop10Artists(),
    getNewSletter(),
    getTitleTop10Artists(),
    getBanner(),
    getArtInside(),
  ]);
}

function HomePage(): React.ReactElement {
  const [data, setData] = useState<any>([]);
  // const [whtlist, setWhtlist] = useState<any>(null);
  const size: Size = useWindowSize();
  const isMobile: boolean = size.width !== undefined && size.width <= 767;
  const [bannerHeight, setBannerHeight] = useState<number>(0);

  // ip check
  // const getIp = async () => {
  //   const WHITELIST_IPS = ['14.52.169.251', '222.114.95.51', '118.219.162.123', '14.138.217.207'];
  //   const res = await axios.get("https://api.ipify.org/?format=json");
  //   const isWhitelisted = WHITELIST_IPS.includes(res.data.ip);
  //   setWhtlist(isWhitelisted);
  // };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // getIp();
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  const fetchData = () => {
    getAllData(isMobile).then((datas) => {
      setData(datas);
    });
  };

  return (
    <TemplateMypage>
      <span itemScope itemType="http://schema.org/Organization">
        <link itemProp="url" href="https://www.artnguide.co.kr" />
        <a itemProp="sameAs" href="https://www.instagram.com/artnguide/"></a>
        <a
          itemProp="sameAs"
          href="https://play.google.com/store/search?q=%EC%95%84%ED%8A%B8%EC%95%A4%EA%B0%80%EC%9D%B4%EB%93%9C&c=apps"
        ></a>
        <a itemProp="sameAs" href="https://www.youtube.com/@Artnguide"></a>
      </span>

      <div style={{ visibility: "hidden", height: 0 }}>
        <a href="https://www.artnguide.co.kr/group-sale/list" title="증권청약">
          증권청약
        </a>
        <a
          href="https://www.artnguide.co.kr/customer-service/public-notice"
          title="공시"
        >
          공시
        </a>
        <a
          href="https://www.artnguide.co.kr/customer-service/sale-guide"
          title="이용가이드"
        >
          이용가이드
        </a>
        <a
          href="https://www.artnguide.co.kr/insight/news-letter/list"
          title="뉴스레터"
        >
          뉴스레터
        </a>
        <a
          href="https://www.artnguide.co.kr/customer-service/art-insight"
          title="아트인사이드"
        >
          아트인사이드
        </a>
      </div>

      <SliderBannerEvent setBannerHeight={setBannerHeight} data={data[6]} />
      {/* {bannerHeight > 0 && <FloatingBanner bannerHeight={bannerHeight} />} */}
      {data[1]?.length > 0 && (
        <MainSlider data={data[1]} onFetchData={fetchData} />
      )}
      {/* {data[1]?.length > 0 && whtlist && <MainSlider data={data[1]} />} */}
      <ArtNumber data={data[2]} />
      {/* {isMobile && <MobileFloatingBanner />} */}
      <ArtReadMore />
      <ArtTop10 data={data[3]} dataTitle={data[5]} />
      <ArtNewSletter data={data[4]} artInside={data[7]} />
    </TemplateMypage>
  );
}

export default HomePage;
